import type { BaseElement } from 'slate';

export const LinkElementType = 'link';

export interface LinkElement extends BaseElement {
  type: typeof LinkElementType;
  url: string;
}
